// src/pages/subscription/Success.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './subscription.css'

const SubscriptionSuccess: React.FC = () => {
  const nav = useNavigate();
  useEffect(() => {
    // 成功画面を数秒表示したあと、管理画面へ戻す
    const timeout = setTimeout(() => nav('/account/subscription'), 3000);
    return () => clearTimeout(timeout);
  }, [nav]);

  return (
    <div className="stripe-back" style={{ padding: 20, textAlign: 'center' }}>
      <h1>ご契約ありがとうございます！</h1>
      <p>サブスクリプションの設定が完了しました。</p>
      <p>3秒後にサブスクリプション管理画面に戻ります...</p>
    </div>
  );
};

export default SubscriptionSuccess;
